import { apiClient } from '@/lib/api-client';

export async function downloadList(
  path: '/v1/expenses/export' | '/v1/expenses/reports/export',
  query: Record<string, unknown>,
  format: 'csv' | 'xlsx',
): Promise<void> {
  const filters = Object.fromEntries(
    Object.entries(query).filter(([key]) => !['offset', 'limit', 'cursor'].includes(key)),
  );
  const { data, error, response } = await apiClient.GET(path, {
    params: { query: { ...filters, format } },
    parseAs: 'blob',
  });
  if (!response.ok || data === undefined) {
    const code =
      typeof error === 'object' && error !== null && 'code' in error ? String(error.code) : '';
    throw Object.assign(new Error('Export failed'), { code });
  }
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${path.includes('/reports/') ? 'note-spese' : 'spese'}.${format}`;
  anchor.click();
  URL.revokeObjectURL(url);
}
